export default {
  name: 'name',
  lastname: 'lastname',
  email: 'email',
  price: 'precio',
  message: 'message',
  months: 'months',
  image: 'image',
  password: 'password',
  catalogue: 'catalogue',
  bank_name: 'bank name',
  password_confirmation: 'confirm password',
  storeName: 'store name',
  storeBotName: 'store bot name',
  storeDescription: 'store description',
  storeCategory: 'store category',
  telegramBotToken: 'telegram bot token',
  description: 'description',
  account_type: 'account type',
  account_number: 'account number',
  owner_full_name: 'owner name',
  owner_idenfication_type: 'document type',
  owner_idenfication: 'owner document',
  dollarPercentage: 'dollar percentage',
  dollarRate: 'dollar rate',
  cancellationReason: 'cancellation reason'
}